





import { OemJsonType } from '@/@types/common'
import { defineObject } from '@/lib/define/use-define'
import {
  computed,
  defineComponent,
  reactive,
  inject,
  watchEffect,
} from '@vue/composition-api'

type stateType = {
  oemInfo: OemJsonType | null
}

export default defineComponent({
  setup(_) {
    const state: stateType = reactive({
      oemInfo: null,
    })

    const oemInfo = inject<{
      value: OemJsonType
    } | null>('$oemInfo', null)

    watchEffect(() => {
      if (oemInfo) {
        state.oemInfo = oemInfo.value
      }
    })

    const appName = computed(() => {
      if (state.oemInfo) {
        return state.oemInfo.oemAppName
      } else {
        return defineObject.APP_INFO.appName
      }
    })

    return {
      appName,
    }
  },
})
